import React, { useContext, useState, useEffect } from 'react';
import { Button, Stack } from '@mui/material';
import TextField from '@mui/material/TextField';
import { HomeContext } from '../utils/contexts/homeContext';
import { useCookies } from 'react-cookie'
import { UserChangePasswordAPIUrl } from '../utils/extensions/functionEx';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export default function ChangePassword(props) {

    const { open, handleClose } = props;
    const { homeState, ShowAPIError, OpenErrorAlert, ClearLoggedUser, OpenSuccessAlert } = useContext(HomeContext);

    const [isLoading, setIsLoading] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [cookies, setCookie] = useCookies(['hplus_home_care_user_session_code']);

    const handlePasswordChangeClick = async () => {
        try {
            if (!homeState.loggedUser.isUserLogged || homeState.loggedUser.userId === 0) {
                OpenErrorAlert('Invalid user session! Please login again.');
                return;
            }
            if (currentPassword.trim().length === 0 || newPassword.trim().length === 0 || confirmNewPassword.trim().length === 0) {
                return;
            }
            if (newPassword.trim() !== confirmNewPassword.trim()) {
                OpenErrorAlert('New password and confirmation do not match.');
                return;
            }

            setIsLoading(true);
            const tempReqJson = {
                user_id: homeState.loggedUser.userId,
                current_password: currentPassword.trim(),
                new_password: newPassword.trim()
            };
            const headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Accept-Encoding", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Hc-App-Auth-Token", cookies.hplus_home_care_user_session_code);

            const response = await fetch(UserChangePasswordAPIUrl(homeState.loggedUser.companyCode), {
                method: "PUT",
                headers: headers,
                body: JSON.stringify(tempReqJson)
            });

            if (response.status === 401) {
                handleClose();
                OpenErrorAlert('User login history expired, please log in again.');
                setCookie('hplus_home_care_user_session_code', '', { path: '/' });
                ClearLoggedUser();
            }
            else if (response.status === 204) {
                OpenSuccessAlert('User login password changed successfully.');
                setIsLoading(false);
                handleClose();
            } else {
                ShowAPIError(response);
                setCurrentPassword('');
                setNewPassword('');
                setConfirmNewPassword('');
                setIsLoading(false);
            }
        }
        catch (error) {
            OpenErrorAlert(error);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmNewPassword('');
            setIsLoading(false);
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="change-password-dialog-title"
                open={open} fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="change-password-dialog-title">
                    Change Password
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Stack spacing={2}>
                        <TextField size="small" fullWidth value={homeState.loggedUser.fullName} disabled
                            label="Employee Name"
                            slotProps={{
                                input: {
                                    readOnly: true
                                },
                            }}
                        />
                        <TextField size="small" fullWidth type="password"
                            autoComplete="hc-current-password-change-form"
                            label="Current Password"
                            value={currentPassword}
                            onChange={(event) => {
                                setCurrentPassword(event.target.value);
                            }}
                            error={currentPassword.trim().length === 0 ? true : false}
                            helperText={currentPassword.trim().length === 0 ? 'Enter current password' : ''}
                        />
                        <TextField size="small" fullWidth type="password"
                            autoComplete="hc-new-password-change-form"
                            label="New Password"
                            value={newPassword}
                            onChange={(event) => {
                                setNewPassword(event.target.value);
                            }}
                            error={newPassword.trim().length === 0 ? true : false}
                            helperText={newPassword.trim().length === 0 ? 'Enter new password' : ''}
                        />
                        <TextField size="small" fullWidth type="password"
                            autoComplete="hc-confirm-password-change-form"
                            label="Confirm New Password"
                            value={confirmNewPassword}
                            onChange={(event) => {
                                setConfirmNewPassword(event.target.value);
                            }}
                            error={confirmNewPassword.trim().length === 0 ? true : false}
                            helperText={confirmNewPassword.trim().length === 0 ? 'Enter confirm new password' : ''}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button loading={isLoading} variant="outlined" loadingPosition="start" onClick={handlePasswordChangeClick}>
                        Submit
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}